/** Dispatched on `window` so the form column can scroll/highlight a question row. */
export const FORM_SCROLL_TO_QUESTION_EVENT = "lgv-form-scroll-to-question";

export type FormScrollToQuestionDetail = {
  questionId: number;
  highlight?: boolean;
  /** Delay before attempting scroll (e.g. after switching category). */
  delayMs?: number;
};

export function dispatchFormScrollToQuestion(detail: FormScrollToQuestionDetail): void {
  window.dispatchEvent(
    new CustomEvent<FormScrollToQuestionDetail>(
      FORM_SCROLL_TO_QUESTION_EVENT,
      { detail }
    )
  );
}
